import { Router } from '@angular/router';
import { Injectable } from '@angular/core';
import { AngularFireAuth } from "@angular/fire/auth";
import firebase from 'firebase/app'
import { Observable } from 'rxjs';
import { MsalService } from '@azure/msal-angular';
import { AuthenticationResult } from '@azure/msal-browser';
import { CommonService } from 'app/shared/common/common.service';
import { UserRoleModel } from 'app/shared/common/commonModel';
import { SecurityService } from '../services/security.service';
import { BaseService } from '../common/base.service';
export interface Login {
  username: string;
  password: string;

  grant_type: string
  //UserId: number;
  //MobileNo: number;
  //Active: boolean;
}
@Injectable()
export class AuthService {
    QuoteParam: string;
  //private user: Observable<firebase.User>;
  //private userDetails: firebase.User = null;

  constructor(public _firebaseAuth: AngularFireAuth, public router: Router, private msalService: MsalService, private baseService: BaseService,private commonService: CommonService, public securityService: SecurityService  ) {
    //this.user = _firebaseAuth.authState;
    //this.user.subscribe(
    //  (user) => {
    //    if (user) {
    //      this.userDetails = user;
    //    }
    //    else {
    //      this.userDetails = null;
    //    }
    //  }
    //);

  }
  UserRoles: string[] = JSON.parse(localStorage.getItem("UserRole"));
  signupUser(email: string, password: string) {
    //your code for signing up the new user
  }

  login() {
    this.msalService.loginPopup().subscribe((response: AuthenticationResult) => {
      this.msalService.instance.setActiveAccount(response.account);
      localStorage.setItem('accesstoken', response.accessToken);
      if (response.account.username.toLowerCase() == ("kirti.kabra@rrglobal.com" || "rajesh.kabra@rrglobal.com")) {
        // if (response.account.username == "disha.gavade@rrglobal.com") {
        localStorage.setItem('username', "shishir.sharma@rrglobal.com");
      }
      else if (response.account.username.toLowerCase() == "yogendrasingh.rawat@rrglobal.com"){

        localStorage.setItem('username', "abhijeet.kumar@rrglobal.com");
      }
      else if (response.account.username.toLowerCase() == ("taruna.wadhwa@rrglobal.com" || "ranjeet.singh@rrglobal.com"))// || "mangal.arjunwade@rrglobal.com" || "arvind.singh@rrglobal.com")) {
      {
        localStorage.setItem('username', "vivek.cm@rrglobal.com");
      }
      else {
        localStorage.setItem('username', response.account.username.toLowerCase());
      }
      
      this.QuoteParam = localStorage.getItem("QuoteId");
      if (this.QuoteParam == undefined || this.QuoteParam == null) {
        this.QuoteParam = "";
      }
      if (this.QuoteParam != "") {       
        this.router.navigate(['/inquiry/inquiry']);
      }
      else {
        this.router.navigate(['/dashboard/dashboard2']);
      }
      
         // this.router.navigate(['/dashboard/dashboard2']);
    
     
     });
    //return this.msalService.loginPopup();
    //uncomment above firebase auth code and remove this temp code
    return new Promise(function(resolve, reject) {
      setTimeout(function () {
       
        resolve(true);
      }, 1000);
    });

  }

  logout() {
   // this._firebaseAuth.signOut();
    this.msalService.logout();
    this.router.navigate(['YOUR_LOGOUT_URL']);
  }
  signinUser(login: Login) {
    //your code for checking credentials and getting tokens for for signing in user
    //return this._firebaseAuth.signInWithEmailAndPassword(email, password)
    return this.securityService.login(login);
    //uncomment above firebase auth code and remove this temp code
    //return new Promise(function(resolve, reject) {
    //  setTimeout(function() {
    //    resolve(true);
    //  }, 1000);
    //});

  }
  isAuthenticated() {
    if (this.msalService.instance.getActiveAccount() != null) {
      return true;
    }
    return true;
  }

  ChangePassword(requestData: any) {
    return this.baseService.postData(requestData, 'Account/ChangePassword');
  }

  ResetPassword(requestData: any) {
    return this.baseService.postData(requestData, 'Account/ResetPassword');
  }

  UserActiveLog(requestData: any) {
    return this.baseService.postData(requestData, 'UserTracking/Login');
  }

  UserLogoutLog() {
    const traceId = localStorage.getItem('traceId');
    if (traceId) {
      this.baseService.postData(null, `UserTracking/Logout?traceId=${traceId}`).subscribe((res: any) => {
        console.log(res)
      },
      error => {
        console.log('error: ' + error)
      });
    }
  }

}
